import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import CheckboxCDS from '@sharedCR/coreDesignSystem/form/CheckboxCDS';
import PropTypes from 'prop-types';

import { PREVIEW_COPY } from '../../previewGeneration.constants';
import { PreviewStepTestIds } from '../../PreviewStep.testIds';

import { getCardStyles, hintStyles, labelStyles } from './ReviewAttestationCard.styles';

const ReviewAttestationCard = ({ checked, disabled, onChange }) => {
  const handleChange = useCallback((_event, nextChecked) => onChange(nextChecked), [onChange]);

  return (
    <Box data-testid={PreviewStepTestIds.REVIEW_CARD} sx={getCardStyles(checked)}>
      <CheckboxCDS
        dataTestId={PreviewStepTestIds.REVIEW_CHECKBOX}
        disabled={disabled}
        label={
          <Typography sx={labelStyles} variant="medium14">
            {PREVIEW_COPY.reviewLabel}
          </Typography>
        }
        value={checked}
        onChange={handleChange}
      />
      <Typography sx={hintStyles} variant="regular12">
        {PREVIEW_COPY.reviewHint}
      </Typography>
    </Box>
  );
};

ReviewAttestationCard.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default memo(ReviewAttestationCard);
